import styled from 'styled-components';

export const ResultsHeaderStyle = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    .results-header-left{
        margin-top: 30px;
        width: 100%;
        display: flex;
        align-items: center;
    }

    .results-google-logo{
        width: 20%;
    }
    .results-searchbar{
        width: 100%;
    }
`;